import axios from 'axios'

export default {
  checkNextStep (data, cb) {
    axios.post('/biz/company/profile/validation/', data)
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            response.error = true
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('can`t next step!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  registUser (userInfo, cb) {
    axios.post('/biz/company/profile/', userInfo)
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('auth fail')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  getUser (id, cb) {
    // 회원 정보 불러오기
    axios.get(`/biz/company/profile/${id}/`)
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          cb(response.data)
        } else if (response.status === 201) {
          cb(response.data)
        } else {
          console.log('get user data fail')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  updateUserInfo (data, cb) {
    // 유저정보 수정.
    axios.put('/biz/company/profile/' + data.id + '/', data)
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          cb(response.data)
        } else if (response.status === 201) {
          cb(response.data)
        } else {
          console.log('update user fail', response)
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  updatePassword (data, cb) {
    // 유저정보 수정.
    axios.post('/biz/company/profile/updatepassword/', data)
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          cb(response.data)
        } else if (response.status === 201) {
          cb(response.data)
        } else {
          console.log('update password fail', response)
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  findMyInfo (data, cb) {
    axios.post('/biz/company/profile/findmyinfo/', data)
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            response.error = true
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('cannot find myinfo')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/user.js